












































import { Component, Vue } from "vue-property-decorator";
import GroupActivitySection from "@/components/groupType/index/GroupActivitySection.vue";
import IndexRuleModal from "./IndexRuleModal.vue";
import { Action, Getter } from "vuex-class";

@Component({
  components: {
    "group-activity-section": GroupActivitySection,
    "index-rule-modal": IndexRuleModal
  }
})
export default class ActivityDeclare extends Vue {
  @Getter("canPay") canPay!: boolean;
  @Getter("gradientColor") gradientColor!: string;
  @Getter("mainTextColor") mainTextColor!: string;
  @Action("changeShowFooter") changeShowFooter!: Function;

  showDeclareModal: boolean = false;

  handleShowModal() {
    this.showDeclareModal = true;
    this.changeShowFooter(false);
  }

  handleHideModal() {
    this.showDeclareModal = false;
    this.changeShowFooter(true);
  }
}
